"use server"
import {pool} from "@/api/database";

export interface UserDataForNavbar {
    username: string;
    role_id: number;
    pfp?: string;
}

export async function getUserDataForNavbar(api_key: string): Promise<UserDataForNavbar | null> {
    const [rows] = await pool.query("SELECT * FROM `felhasznalok` WHERE api_key = ?", [api_key]);
    if (!rows || (rows as UserDataForNavbar[]).length === 0) {
        return null;
    } else {
        return (rows as UserDataForNavbar[])[0];
    }
}

export async function getUserId(api_key: string): Promise<number | null> {
    const [rows]: any = await pool.query(
        "SELECT user_id FROM `felhasznalok` WHERE api_key = ?",
        [api_key]
    );

    if (!rows || rows.length === 0) {
        return null;
    }

    return rows[0].user_id;
}
